import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, inject, onMounted } from "vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import SingleSelect from "../dropdowns/single-select.vue";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";


export default /*#__PURE__*/_defineComponent({
  __name: 'new-contact-type-lookup',
  props: {
  /**
   * The numeric value used with `v-model` to bind the component state. This typically represents an ID or a selected value.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the input control is required.
   * @type {boolean}
   * @default false
   */
  requiredInput: {
    type: Boolean,
    default: false,
  },

  /**
   * The validation group name used for form validation.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
   * @event update:modelValue
   * @param {Number} value - The new value to be updated in the model.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const selectedValueId = computed({
  get: () => props.modelValue,
  set: (value: number) => emit("update:modelValue", value),
});

const apiClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const lookupItems = ref<IDDescriptionPair[]>([]);

onMounted(async () => {
  // Call api for a list of lookup items to display. These aren't cached as there may be a lot of data
  lookupItems.value = await apiClient.httpGet<IDDescriptionPair[]>(
    `/ContactTypes/NewContact`,
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SingleSelect, {
    modelValue: selectedValueId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValueId).value = $event)),
    "data-source": lookupItems.value,
    readOnly: props.readOnly,
    label: __props.label,
    requiredInput: props.requiredInput,
    validationGroup: props.validationGroup
  }, null, 8, ["modelValue", "data-source", "readOnly", "label", "requiredInput", "validationGroup"]))
}
}

})